<template>
  <div class="modal-sidebar__cats">
    <a href="javascript:;" class="font-size-16 font-sanpro primary-color display-block modal-sidebar__cats__back" @click="handleBackBookList">
      <span class="icon-arrow-left primary-color font-size-12"><span class="path1 priamry-color"></span><span class="path2 priamry-color"></span></span> 
      Trở lại
    </a>
    <div class="modal-sidebar__cats__list modal-sidebar__cats__tpl">
      <v-runtime-template :template="template" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VRuntimeTemplate from "v-runtime-template";
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getCatOfExerciseOtherOrThematic } from '@/modules/exercises/_api'
import { STORE_KEY } from './../../_store/constants'
import mixinExercise from '@/modules/exercises/_store/mixinExercise'
import { apiGetQuestionSampleByChapter } from './../../_api/exam'

export default {
  name: 'SidebarCatsOfAutoTest',
  mixins: [ mixinExercise ],
  props: {
    keyWord: String
  },
  components: {
    VRuntimeTemplate,
    vueCustomScrollbar
  },
  data () {
    return {
      dataCatsThematic: [],
      catsFlatLength: 0,
      template: '',
      idsCatActive: [],
      checkActive: 0
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['chapterIdQuestion', 'paramsGetQuestionsSample', 'paramFilterQuestionsByChapter'])
  },
  watch: {
    paramFilterQuestionsByChapter: 'getQuestions'
  },
  mounted () {
    Promise.all([this.getAllChapter(), this.getQuestions()])
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetChapterIdQuestions', 'acSetParamsFilterQuestionChapter', 'acSetQuestionSample']),

    getAllChapter () {
      let self = this
      self.setLoading(true)
      getCatOfExerciseOtherOrThematic(this.paramsGetQuestionsSample).then(async res => {
        if (res && res.data && !res.errors) {
          self.dataCatsThematic = await self.flatenCatsExOtherOrThematic(res.data)
          // self.acSetCatsFlat(self.dataCatsThematic)
          // Set cat active
          await self.getCatActive()
          self.catsFlatLength = self.dataCatsThematic.length
          self.template = `<vue-custom-scrollbar id="book_viewer__cats" class="scroll-area scroll-area__cats scroll-area__cats__exercise lesson-css"><div class="book-viewer__cats__wrap">`
          self.convertCatsData(res.data)
          self.template +=  `</div></vue-custom-scrollbar>`
        }
      }).finally(() => self.setLoading(false))
    },

    getCatActive () {
      this.idsCatActive = []
      let indexCatActive = this.dataCatsThematic ? this.dataCatsThematic.findIndex(cat => cat.chapterId === this.paramFilterQuestionsByChapter.chapterId) : -1
      if (indexCatActive > -1) {
        let chapterIdCurr = this.dataCatsThematic[indexCatActive].chapterId
        let catActive = this.dataCatsThematic[indexCatActive].parents
        let catActiveLength = catActive.length

        this.idsCatActive.push(this.dataCatsThematic[indexCatActive].chapterId)
        catActiveLength > 0 && catActive.map((cat, index) => {
          this.idsCatActive.push(cat.chapterId)
        })
      }
    },

    async convertCatsData(data, parent = null, isChild = false, childIndex = 0) {
      let self = this;
      if (isChild) {
        self.template += `<b-collapse id="cat_${childIndex}_${parent.chapterId}" :visible="${parent && parent.chapterId && self.idsCatActive && self.idsCatActive.includes(parent.chapterId)}" accordion="my-accordion-${childIndex}" role="tabpanelchild"><b-card-body>`
      }
      if (data && data.length > 0) {
        self.template += `<ul class="margin-0 p-0 list-style-none">`
        let lengthData = data.length
        await data.map(async (cat, index) => {
          self.template += `<li :class="{'active': paramFilterQuestionsByChapter.chapterId === ${cat.chapterId}}">
                              <a
                                href="javascript:;"
                                class="font-sanpro primary-color-txt font-size-16 display-flex display-flex-center justify-content-between w-190"
                                v-b-toggle.cat_${childIndex + 1}_${cat.chapterId}
                                @click="getDetailThematicOrQuestionOther({collapseId: 'cat_${childIndex + 1}_${cat.chapterId}', chapterId: ${cat.chapterId}, hasChild: ${cat.listChapterChild && cat.listChapterChild.length > 0}, childIndex: ${childIndex + 1}})"
                              >
                                <span>${cat.title}</span>
                              </a>`
          if (cat.listChapterChild && cat.listChapterChild.length > 0) {
            self.convertCatsData(cat.listChapterChild, cat, true, childIndex + 1)
          }
          self.template += `</li>`
          if(index === lengthData - 1) {
            self.template += `</ul>`
          }
          if (isChild && index === lengthData - 1) {
            self.template += `</b-card-body></b-collapse>`
          }
        })
      }
    },

    getDetailThematicOrQuestionOther(cat = null) {
      // this.checkActive = cat.chapterId
      this.acSetParamsFilterQuestionChapter({...this.paramFilterQuestionsByChapter, chapterId: cat.chapterId})
      // let nameRouter = this.typeId === TYPE_EXERCISE_THEMATIC ? 'exerciseThematicDetail' : 'exerciseOtherDetail'
      // let queryParams = this.typeId === TYPE_EXERCISE_THEMATIC ? {cauhoi: 0} : {cauhoi: 1}
      // this.chapterId !== cat.chapterId && this.$router.push({ name: nameRouter, params: {...this.routerParams, id: cat.chapterId }, query: queryParams })
      // this.typeId === TYPE_EXERCISE_THEMATIC && parseInt(this.$route.query.cauhoi) !== 0 && this.$router.replace({query: queryParams})
    },

    handleBackBookList () {
      this.acSetParamsFilterQuestionChapter({...this.paramFilterQuestionsByChapter, chapterId: 0})
    },

    getQuestions () {
      let self = this
      self.setLoading(true)
      apiGetQuestionSampleByChapter(self.paramFilterQuestionsByChapter).then(res => {
        // console.log('Question tktdg: ', res, self.dataCatsThematic)
        if (!res || res.length === 0) {
          let indexCatFlat = self.dataCatsThematic.findIndex(cat => cat.chapterId === self.paramFilterQuestionsByChapter.chapterId)
          // console.log('Index cat: ', indexCatFlat, self.paramFilterQuestionsByChapter.chapterId)
          indexCatFlat > -1 && indexCatFlat < catsFlatLength - 1 && self.getDetailThematicOrQuestionOther(self.dataCatsThematic[indexCatFlat + 1])
        } else {
          self.acSetQuestionSample(res) 
        }
        res && self.acSetQuestionSample(res)
      }).finally(() => self.setLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.w-190{
  width: 190px;
}

</style>